import i18n from 'i18next'

/**
 * Plan feature labels come from the plan API (stripe_plans rows), and older rows still
 * describe the product as stories. Map the known labels to lesson wording in the interface
 * language, so every plan surface reads the same. Anything not listed passes through unchanged.
 * The strings live in `common` (planFeatures.*): this runs outside React, and `common` is the
 * one namespace that is always loaded.
 */
const KNOWN_FEATURE_KEYS: Record<string, string> = {
  'daily story in mandarin': 'common:planFeatures.dailyLesson',
  'two weekly stories in mandarin': 'common:planFeatures.twoLessonsAWeek',
  'daily native recording': 'common:planFeatures.nativeAudio',
  'native recording': 'common:planFeatures.nativeAudio',
  'daily story quiz': 'common:planFeatures.quiz',
  'story quiz': 'common:planFeatures.quiz',
  'daily new characters': 'common:planFeatures.newCharacters',
  'daily writing prompt': 'common:planFeatures.writeSpeak',
  'writing prompt': 'common:planFeatures.writeSpeak',
}

/**
 * History keeps a number of studied lessons, not days: older rows worded it as days, newer ones
 * say "Your last N studied lessons". The N, or null when the label is not a history label.
 */
export const pastLessonsCount = (label?: string | null): number | null => {
  const raw = (label ?? '').trim()
  const match = raw.match(
    /^(?:(\d+) days of past (?:featured )?stories|lessons from the last (\d+) days|your last (\d+) studied lessons)$/i,
  )
  return match ? Number(match[1] || match[2] || match[3]) : null
}

export const planFeatureLabel = (label?: string | null): string => {
  const raw = (label ?? '').trim()
  const pastLessons = pastLessonsCount(raw)
  if (pastLessons !== null) return i18n.t('common:planFeatures.pastLessons', { count: pastLessons })
  const key = KNOWN_FEATURE_KEYS[raw.toLowerCase()]
  return key ? i18n.t(key) : raw
}
